var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H52C56.4183 0 60 3.58172 60 8V52C60 56.4183 56.4183 60 52 60H8C3.58172 60 0 56.4183 0 52V8Z",
    fill: "url(#paint0_linear_182_133)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.23 40.434H24.8507V36.7674H28.5174V35.1467H24.8507V31.48H23.23V35.1467H19.5634V36.7674H23.23V40.434ZM32.3967 39.059H40.434V37.4384H32.3967V39.059ZM32.3967 34.4757H40.434V32.855H32.3967V34.4757ZM33.8487 27.2285L36.4154 24.6619L38.982 27.2285L40.1315 26.079L37.5649 23.4904L40.1315 20.9237L38.982 19.7742L36.4154 22.3409L33.8487 19.7742L32.6992 20.9237L35.2659 23.4904L32.6992 26.079L33.8487 27.2285ZM20.0217 24.3007H28.059V22.68H20.0217V24.3007ZM18.2947 44.6654C17.4501 44.6654 16.7455 44.383 16.1809 43.8184C15.6162 43.2537 15.3333 42.5485 15.332 41.7027V18.2947C15.332 17.4501 15.615 16.7455 16.1809 16.1809C16.7468 15.6162 17.4514 15.3333 18.2947 15.332H41.7045C42.5479 15.332 43.2525 15.615 43.8184 16.1809C44.3843 16.7468 44.6666 17.4514 44.6654 18.2947V41.7045C44.6654 42.5479 44.383 43.2525 43.8184 43.8184C43.2537 44.3843 42.5485 44.6666 41.7027 44.6654H18.2947ZM18.2947 42.832H41.7045C41.9856 42.832 42.2441 42.7147 42.48 42.48C42.7159 42.2454 42.8333 41.9863 42.832 41.7027V18.2947C42.832 18.0124 42.7147 17.7533 42.48 17.5174C42.2454 17.2815 41.9863 17.1641 41.7027 17.1654H18.2947C18.0124 17.1654 17.7533 17.2827 17.5174 17.5174C17.2815 17.752 17.1641 18.0111 17.1654 18.2947V41.7045C17.1654 41.9856 17.2827 42.2441 17.5174 42.48C17.752 42.7159 18.0105 42.8333 18.2929 42.832",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_182_133",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3896BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/Tax.e7aecd79b5b30b15de627ffcdb8729e3.svg";
export { ForwardRef as ReactComponent };